<template>
  <div>
    <b-modal
        ref="entityModalSelect"
        :size="size"
        @ok="handleOk"
    >
      <!--                :title="selectFrom"-->
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter v-if="entity" :entity="entity"/>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emMenuResultTable" class="content">
        <div class="card my-1">
          <div
              id="collapseTwo"
              class="collapse show"
              aria-labelledby="headingTwo"
              data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table v-if="entity" :entity="entity" selectActionEnable checkboxColumnDisabled inline-actions-disabled
                        editDisable isModal exportDisabled @entitySelected="handleEntitySelected"></em-table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EmFilter from "@/components/em/EmFilter";
import EmTable from "@/components/em/EmTable";
import EmModalEntitySelector from "@/components/em/EmModal/EntitySelector";

export default {
  name: "em-modal-normal-input-entity-selector",
  components: {EmTable, EmFilter, EmModalEntitySelector},
  props: {
    size: {
      type: String,
      default: "lg"
    },
    level: {
      type: Number,
      default: 1
    },
    entity: {
      type: String
    },
    multipleSelection: {
      type: Boolean,
      default: false
    },

  },
  methods: {
    //直接点击ok,就等于选择了null,可以清空相应内容
    handleOk() {
      this.handleEntitySelected(null)
    },
    handleEntitySelected(selectedItem) {
      //向外触发事件
      this.$emit("entityModalSelectSelected", selectedItem);
      this.$nextTick(() => {
        // Wrapped in $nextTick to ensure DOM is rendered before closing
        this.hideModal()
      });
    },
    showModal() {
      this.$refs['entityModalSelect'].show();
    }    ,
    hideModal() {
      if (this.$refs['entityModalSelect'] !== undefined) {
        this.$refs['entityModalSelect'].hide();
      }
    }
  }
};
</script>
